import router from '@/router';
import Vue from 'vue';

const VUE_APP_ZENDESK_URI = process.env.VUE_APP_ZENDESK_URI;

// Paths that company accounts cannot use (see companyGuard on these routes).
const COMPANY_SINGLE_SCAN_PATH_PREFIXES = ['/scans', '/scan/create', '/scan/upload'];

export function isCompanyBlockedRedirectPath(path) {
  if (!path || typeof path !== 'string') {
    return false;
  }
  const normalized = path.split('?')[0];
  return COMPANY_SINGLE_SCAN_PATH_PREFIXES.some(
    (p) => normalized === p || normalized.startsWith(`${p}/`)
  );
}

/**
 * Resolves where to send the user after auth (sign-in or hitting an auth page while logged in).
 * Use with router.push or next({ ...location }) so Vue Router does not leave a dangling navigation.
 */
export function getPostLoginRoute(userType, redirect) {
  const rawRedirect = Array.isArray(redirect) ? redirect[0] : redirect;
  const isHacker = userType === 'hacker';

  if (rawRedirect && typeof rawRedirect === 'string') {
    if (!isHacker && isCompanyBlockedRedirectPath(rawRedirect)) {
      return { name: 'Integrations', replace: true };
    }
    return { path: rawRedirect, replace: true };
  }
  if (isHacker) {
    return { name: 'Scans', replace: true };
  }
  return { name: 'Integrations', replace: true };
}

export const routeUserToPageByTypeAfterLogin = async (
  userType,
  _isGetStartedCompleted,
  redirect
) => {
  await router.push(getPostLoginRoute(userType, redirect));
};

export const redirectUserToZendeskAfterLogin = async () => {
  const { data } = await Vue.axios.get('/private/ui/zendesk/payload');
  if (data && data.payload) {
    document.location.href = `${VUE_APP_ZENDESK_URI}/access/jwt?jwt=${data.payload}`;
  } else {
    await router.push({ name: 'Root' });
  }
};
